<script>
export default {
  name: 'RwLoader2',
};
</script>

<template>
  <div class="text-center rwloader2 mt-2">
    <v-progress-circular :size="50" color="primary" indeterminate />
  </div>
</template>
